/**
 * Adds a loading state to the "You may also like" add-to-cart buttons in the
 * cart drawer while the add request is in flight.
 *
 * This is a standalone theme asset — it does NOT modify any base theme JS.
 * It attaches a single delegated listener to the document, so it keeps working
 * after the cart drawer is morphed (re-rendered) on every cart update.
 */
(() => {
  if (window.__cartRecLoadingInit) return;
  window.__cartRecLoadingInit = true;

  const LOADING_CLASS = 'cart-xs__add--loading';

  /**
   * Show the spinner as soon as a recommendation "Add" button is clicked.
   * We only add a class (never `disabled`) so the form still submits.
   */
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const button = target.closest('.cart-xs__add--submit');
      if (!button) return;

      // Don't show loading if the form is invalid and won't submit.
      const form = button.closest('form');
      if (form && typeof form.checkValidity === 'function' && !form.checkValidity()) return;

      button.classList.add(LOADING_CLASS);
      button.setAttribute('aria-busy', 'true');
    },
    true
  );

  /**
   * Clear any lingering loading state once the add resolves.
   * On success the drawer morph removes the button anyway; on error the button
   * stays in the DOM, so this restores it.
   */
  const clearLoading = () => {
    for (const button of document.querySelectorAll(`.${LOADING_CLASS}`)) {
      button.classList.remove(LOADING_CLASS);
      button.removeAttribute('aria-busy');
    }
  };

  // 'cart:update' is also the event name dispatched by CartAddEvent.
  document.addEventListener('cart:update', clearLoading);
  document.addEventListener('cart:error', clearLoading);
})();
